import { MembershipTypes } from '@r-and-a-shared-ui/auth-client';
import { StaticImageData } from 'next/image';

export const membershipTypeIcons: Record<MembershipTypes, StaticImageData | string> = {
  [MembershipTypes.None]: '',
  [MembershipTypes.OneClub]: '',
  [MembershipTypes.OneClubAdvantage]: '',
};